<template>
  <div class="printer-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('printer_edit')"/>
    <v-container grid-list-xl fluid>
    <v-layout row wrap>
    <v-flex sm12>
      <h1><v-icon large>mdi-printer-3d</v-icon>{{$t('printer.printers')}}</h1>
    </v-flex>
    <v-flex lg12>
    <PrinterListCard></PrinterListCard>
    </v-flex>
    </v-layout>
    </v-container>
  </div>
</template>

<script>

import ListMixin from '../../mixins/ListMixin';

import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import PrinterListCard from '../../components/printer/parc.vue'

export default {
  name: 'PrinterList',
  servicePrefix: 'Printer',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    PrinterListCard,

  },
};
</script>
